<template>
  <div class="box-room">
	<div class="user">
		<img @click="goBack" class="user-img" src="../../../assets/image/zhibojian_fanhui@2x.png" alt="" />
		<div class="user-content" v-if="data && data.chatRoomDetails" @click="handleShowZbjl">
			<img :src="data.chatRoomDetails.backgroundUrl" alt="" />
			<div class="user-content-div">
				<span class="user-content-div-span">{{data.chatRoomDetails.name}}</span>
				<span class="user-content-div-span1">ID：{{data.chatRoomDetails.thirdId}}</span>
			</div>
		</div>
	</div>
	<div class="box-left">
		<img class="bj" v-if="data && data.chatRoomDetails" :src="data.chatRoomDetails.backgroundUrl" alt="" />
		<div class="box-left-top">
			<tengxunyun ref="txy"v-if="isZb == 2"/>
			<div class="tengxunyunzb" v-if="isZb == 1">
				<tengxunyunzb ref="txyzb"/>
			</div>
			<div class="txy-list-btn" v-if="$route.query.liveId != $store.state.liveId">
				<div class="txy-list-btn-item" @click="handleUpdateMuted">
					<img v-if="muted" src="../../../assets/image/zhibojian_shengyin_kai@2x.png" alt=""/>
					<img v-if="!muted" src="../../../assets/image/zhibojian_shengyin_guan@2x.png" alt=""/>
					<span>{{$t('all.shengyin')}}</span>
				</div>
				<div class="txy-list-btn-item" @click="handleUpdateSvga">
					<img v-if="svga" src="../../../assets/image/zhibojian_liwutexiao_kai@2x.png" alt=""/>
					<img v-if="!svga" src="../../../assets/image/zhibojian_liwutexiao_guan@2x.png" alt=""/>
					<span>{{$t('all.liwutexiao')}}</span>
				</div>
			</div>
			<quanbuliwu v-if="show_gdlw" @close="show_gdlw = false" @updateUser="handleUpdateUser"/>
			<gouwuche v-if="show_gwc" @close="show_gwc = false"/>
			<kuaijieduanyu 
			  @close_kjdy="show_kjdy = false"
			  v-if="show_kjdy"/>
			<guanliyuan
			  ref="gly"
			  @close_gly="show_gly = false"
			  v-if="show_gly"/>
			<zhibojilu
			  @close_zbjl="show_zbjl = false"
			  v-if="show_zbjl"/>
			<gongao
			  @close_gg="show_gg = false"
			  @update_gg="updateGg"
			  v-if="show_gg"/>
		</div>
		<div class="box-left-bottom">
		  <liwu ref="liwu" @show_gdlw="hanldeShowGdlw" v-if="isZb == 2 && isShowGift"/>
		  <zhuboshezhi 
		    ref="zhuboshezhi" 
			@setVol="handleSetVol"
			@show_kjdy="handleShowKjdy"
			@show_gly="handleShowGly"
			@show_gg="handleShowGg"
			@show_svga="hanldeShowSvga"
			v-if="isZb == 1 || !isShowGift"/>
		 <div class="gouwuche" @click="handleShowGwc" v-if="isZb == 2 && isShowGift">
		  	<img src="../../../assets/image/zhibojian_gouwuche@2x.png" alt="" />
			<span>{{$t('all.gouwuche')}}</span>
		  </div>
		</div>
		<liwudonghua ref="lwdh"/>
	</div>
	<div class="box-right">
		<zaixianguanzhong ref="zaixian" @show_user="handleShowUser"/>
		<danmu 
		  @addSvgaToQueue="hanldeAddSvgaToQueue"
		  @changeUser="updateChangeUser" 
		  @show_user="handleShowUser"
		  @addLwToQueue="handleAddLwToQueue"
		  @pulling="updatePulling"
		  @updataNotice="handleShowGg"
		  ref="danmu"
		  />
		<user ref="user" @addAdmin="handleAddAdmin"/>
	</div>
	<guanbizhibo ref="gbzb"/>
  </div>
</template>

<script>
import { getChatRoomDetails } from "@/api/zhibo";
import zaixianguanzhong from "../../../components/zaixianguanzhong/zaixianguanzhong.vue"
import danmu from "../../../components/danmu/danmu.vue"
import liwu from "../../../components/liwu/liwu.vue"
import gouwuche from "../../../components/gouwuche/gouwuche.vue"
import gengduoliwu from "../../../components/gengduoliwu/gengduoliwu.vue"
import tengxunyun from "../../../components/tengxunyun/tengxunyun.vue"
import tengxunyunzb from "../../../components/tengxunyunzb/tengxunyunzb.vue"
import liwudonghua from "../../../components/liwudonghua/liwudonghua.vue"
import quanbuliwu from "../../../components/quanbuliwu/quanbuliwu.vue"
import zhuboshezhi from "../../../components/zhuboshezhi/zhuboshezhi.vue"
import kuaijieduanyu from "../../../components/kuaijieduanyu/kuaijieduanyu.vue"
import guanliyuan from "../../../components/guanliyuan/guanliyuan.vue"
import user from "../../../components/user/user.vue"
import zhibojilu from "../../../components/zhibojilu/zhibojilu.vue"  
import gongao from "../../../components/gongao/gonggao.vue"
import playSvga from "../../../components/playSvga/playSvga.vue"
import guanbizhibo from "../../../components/guanbizhibo/guanbizhibo.vue"
export default {
  components: {
    zaixianguanzhong,
	danmu,
	liwu,
	gouwuche,
	gengduoliwu,
	tengxunyun,
	liwudonghua,
	quanbuliwu,
	tengxunyunzb,
	zhuboshezhi,
	kuaijieduanyu,
	guanliyuan,
	user,
	zhibojilu,
	playSvga,
	gongao,
	guanbizhibo
  },
  data() {
    return {
	  data:'',
	  show_gdlw:false,
	  show_gwc:false,
	  show_kjdy:false,
	  show_gly:false,
	  show_zbjl:false,
	  show_gg:false,
	  muted:true,
	  svga:true,
	  isZb:-1,
	  isShowGift:true
    };
  },
  mounted() {
	this.getChatRoomDetails()
  },
  methods: {
	async getChatRoomDetails(){
		const res = await getChatRoomDetails({liveId:this.$route.query.liveId})
		this.data = res.data
		if(this.$store.state.userId && res.data.chatRoomDetails.hostUserInfo.userId == JSON.parse(this.$store.state.userId)){
			if(res.data.chatRoomDetails.liveType == 2){
				this.isZb = 2
				this.isShowGift = false
			}else{
				this.isZb = 1
				this.isShowGift = false
			}
		}else{
			this.isZb = 2
			this.isShowGift = true
		}
	},
    //更改在在线信息
	updateChangeUser(){
		this.$refs.zaixian.getChatRoomOnlineUserList()
		this.$refs.zaixian.getChatRoomOnlineUserCount()
	},
	//显示礼物动画
	handleAddLwToQueue(data){
		this.$refs.lwdh.addLwToQueue(data)
	},
	//返回上一页
	goBack (){
		if(this.isZb == 1){
			this.$refs.gbzb.showModel()
		}else{
			this.$router.go(-1);
		}
	},
	//显示更多礼物
	hanldeShowGdlw(){
		this.show_gdlw = true
		this.show_gwc = false
		this.show_zbjl = false
	},
	//显示购物车
	handleShowGwc(){
		this.show_gdlw = false
		this.show_gwc = true
		this.show_zbjl = false
	},
	//送完礼物更新用户信息
	handleUpdateUser(){
		this.$refs.liwu.getPresentUserInfo()
	},
	//设置音量
	handleSetVol(data){
		this.$refs.txyzb.setVolume(data)
	},
	//显示快捷短语
	handleShowKjdy(){
		this.show_kjdy = true
		this.show_gly = false
		this.show_zbjl = false
		this.show_gg = false
	},
	//显示管理员
	handleShowGly(){
		this.show_kjdy = false
		this.show_gly = true
		this.show_zbjl = false
		this.show_gg = false
	},
	//显示用户信息
	handleShowUser(data){
		this.$refs.user.showUser(data)
	},
	//加载管理员列表
	handleAddAdmin(){
		if(this.show_gly){
			this.$refs.gly.getChatRoomAdminUserList()
		}
	},
	//显示直播记录
	handleShowZbjl(){
		this.show_gdlw = false
		this.show_gwc = false
		this.show_kjdy = false
		this.show_gly = false
		this.show_zbjl = true
		this.show_gg = false
	},
	//显示公告
	handleShowGg(){
		this.show_gdlw = false
		this.show_gwc = false
		this.show_kjdy = false
		this.show_gly = false
		this.show_zbjl = false
		this.show_gg = true
	},
	//成功修改公告
	updateGg(){
		this.show_gg = false
		this.$refs.danmu.getChatRoomDetails()
	},
	//赠送礼物
	hanldeAddSvgaToQueue(data){
		if(this.isZb == 1){
			if(this.svga){
				//this.$refs.txy.addGiftToQueue(data)
				this.$refs.txyzb.addGiftToQueue(data)
			}
		}else{
			//this.$refs.txyzb.addGiftToQueue(data)
			this.$refs.txy.addGiftToQueue(data)
		}
	},
	//主播开启或者关闭特效
	hanldeShowSvga(data){
		this.$refs.txyzb.showSvga(data)
	},
	//观众关闭开启声音
	handleUpdateMuted(){
		this.muted = !this.muted
		this.$refs.txy.updateMuted(this.muted)
	},
	//观众关闭开启特效
	handleUpdateSvga(){
		this.svga = !this.svga
		this.$refs.txy.updateSvga(this.svga)
	},
	//主播进入直播间重新拉流看看
	updatePulling(){
		if(this.$refs.txy){
			setTimeout(v=>{
				this.$refs.txy.refreshPlay()
				console.log('重新拉流了')
			},2000)
		}
	}
  },
};
</script>
<style scoped lang="scss">
	@import "./zhibojian.css";
</style>


// WEBPACK FOOTER //
// zhibojian.vue?3cb2a7c7